<template>
  <div class="contact-text-section">
    <text-content-wrapper>
      <template v-slot:col-1>
        <div class="heading-2" v-html="fields.field_one.value.text"></div>
        <div class="heading-3-bold" v-html="fields.field_one.value.text2"></div>
      </template>
      <template v-slot:col-2>
        <div class="lead-1"v-html="fields.field_three.value.text"></div>
        <div class="paragraph-1"v-html="fields.field_three.value.text2"></div>

<!--        <seu-button-->
<!--          :label="fields.field_three.value.buttonLabel"-->
<!--          :button-icon-before="fields.field_three.value.buttonIconLeft"-->
<!--          button-link="https://calendly.com/swiss-engineers-united/30min-seu-meeting"-->
<!--          target="_blank"-->
<!--        />-->
      </template>
    </text-content-wrapper>
  </div>
</template>

<script>
import TextContentWrapper from "/seu-frontend/sections/general/TextContentWrapper";
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: 'ContactTextSection',
  components: {SeuButton, TextContentWrapper},
  props: {
    fields: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
@import "ContactTextSection.scss";
</style>
